'use strict';

import numberCounter from '../../../src/js/shared/numberCounter';

const $ = jQuery.noConflict();
$(function() {
	const banner = {
		init: function() {
			numberCounter.init('.js-counter-num', '.js-banner-counter', 10);
		},
	};
	banner.init();
});